import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanMatch,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment
} from '@angular/router';
import {AuthService} from './auth.service';
import {ParamService} from './param.service';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanMatch {
    constructor(
        private authService: AuthService,
        private router: Router,
        private paramService: ParamService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const urlWithoutParams = '';
        const params = '';
        return this.checkLogin(urlWithoutParams, params);
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        console.log('activate child');

        return this.canActivate(route, state);
    }

    canMatch(route: Route, segments: UrlSegment[]): boolean {
        console.log('can match');

        const url = `/${route.path}`;
        return this.checkLogin(url, '');
    }

    checkLogin(url: string, params: any): boolean {
        if (this.authService.checkIfValidSWYUserInfo()) {
            return true;
        }
        return false;
    }

}
